module.exports = __webpack_public_path__ + "img/check.0fa202c8.svg";